export class SchemaRegistrySchemaRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "credentialsProfileId",
            "baseName": "credentialsProfileId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "schemaRegistry",
            "baseName": "schemaRegistry",
            "type": "SchemaRegistryConfig",
            "format": ""
        },
        {
            "name": "subject",
            "baseName": "subject",
            "type": "string",
            "format": ""
        },
        {
            "name": "version",
            "baseName": "version",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SchemaRegistrySchemaRequest.attributeTypeMap;
    }
    constructor() {
    }
}
